import React from 'react';
import { FunnelIcon } from '@heroicons/react/24/outline';

// FilterButton component to toggle between showing all accounts and only unallocated accounts
interface FilterButtonProps {
  showOnlyUnallocated: boolean;
  setShowOnlyUnallocated: React.Dispatch<React.SetStateAction<boolean>>;
}

const FilterButton: React.FC<FilterButtonProps> = ({ showOnlyUnallocated, setShowOnlyUnallocated }) => {
  return (
    <button
      onClick={() => {
        setShowOnlyUnallocated(!showOnlyUnallocated);
      }}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm ${
        showOnlyUnallocated ? 'bg-dataops-yale-blue text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      }`}
    >
      <FunnelIcon className="h-4 w-4" />
      {showOnlyUnallocated ? 'Show All Accounts' : 'Show Only Unallocated'}
    </button>
  );
};

export default FilterButton;
